module.exports = __webpack_public_path__ + "static/media/booth-bg.8ba8e70a.png";